import { render, staticRenderFns } from "./price-control.vue?vue&type=template&id=ba8b1e9e&scoped=true"
import script from "./price-control.vue?vue&type=script&lang=js"
export * from "./price-control.vue?vue&type=script&lang=js"
import style0 from "./price-control.vue?vue&type=style&index=0&id=ba8b1e9e&prod&lang=scss&scoped=true"
import style1 from "./price-control.vue?vue&type=style&index=1&id=ba8b1e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_7sjryms56nihpddmmbru7sns3m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b1e9e",
  null
  
)

export default component.exports